import styled, { injectGlobal } from 'styled-components';

injectGlobal`
	* {
		box-sizing: border-box;
	}

	html {
		padding: 0;
		margin: 0;
		overflow-x: hidden;
	}

	body {
		font: normal 16px/normal 'Open Sans', sans-serif;
		padding: 0;
		margin: 0;
		overflow-x: hidden;
	}
`;

const StyledApp = styled.div`
	padding: 20px;
`;

export default StyledApp;

export const Intro = styled.div`
	text-align: center;
	display: flex;
	align-items: center;
	align-content: center;
	justify-content: center;
	flex-wrap: wrap;
	height: 90vh;
	width: 100vw;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	background: rgba(255, 255, 255, 0.9);
	padding: 0 20px;
	p {
		width: 100%;
	}
`;

export const Logo = styled.img`
	width: 100px;
	position: absolute;
	z-index: 20;
	bottom: 20px;
	left: 50%;
	margin-left: -50px;
	opacity: 0.5;
`;



// WEBPACK FOOTER //
// ./src/App.styles.js